import { DateTime } from 'luxon';

import TableLayout, {
  TableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import { ModuleTable } from 'dashboard/modules/Table/model';
import Card from 'design-system/components/Card';
import { DATE_AND_TIME_FORMAT } from 'lib/constants/luxonFormats';

interface TablePreviewProps {
  module: ModuleTable;
}

// TODO: use preview_case_query_results data to render table preview
const TablePreview = ({ module }: TablePreviewProps) => {
  return (
    <Card data-test={`module__table-preview--${module.token}`}>
      <Card.Body>
        <Card.Title>{module.title}</Card.Title>
        <TableLayout
          isLoading={false}
          headerTR={
            <>
              <TableTH>ID</TableTH>
              <TableTH>User</TableTH>
              <TableTH>Role</TableTH>
              <TableTH>Created at</TableTH>
            </>
          }
          nullState={<TableNullState>No rows found</TableNullState>}
        >
          <TableTR>
            <TableTD>1</TableTD>
            <TableTD>John Doe</TableTD>
            <TableTD>Admin</TableTD>
            <TableTD>{DateTime.fromSQL('2022-01-01').toFormat(DATE_AND_TIME_FORMAT)}</TableTD>
          </TableTR>
          <TableTR>
            <TableTD>2</TableTD>
            <TableTD>Jane Doe</TableTD>
            <TableTD>Admin</TableTD>
            <TableTD>{DateTime.fromSQL('2022-03-01').toFormat(DATE_AND_TIME_FORMAT)}</TableTD>
          </TableTR>
        </TableLayout>
      </Card.Body>
    </Card>
  );
};

export default TablePreview;
